import { render, staticRenderFns } from "./ResendOtpViaEmail.vue?vue&type=template&id=e785bcee&"
import script from "./ResendOtpViaEmail.vue?vue&type=script&lang=js&"
export * from "./ResendOtpViaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports